import useCommonGlobalStore, { commonZustandGlobalSelector, shallow } from '../store/common.store'
import { Navigate, Outlet } from 'react-router-dom'

const PrivateRoute = () => {
    const { authToken } = useCommonGlobalStore(commonZustandGlobalSelector, shallow)
    return authToken ? <Outlet /> : <Navigate to={'/login'} />
}

export default PrivateRoute